import { Space, Typography } from "antd";
import { format } from "date-fns";
import { useMemo, useState } from "react";
// import { AskInfluencerCommercials } from "./askInfluencerCommercials/AskInfluencerCommercials";
// import InflunencerCommercialsDropDown from "./InfluencerCommercialsDropDown/InflunencerCommercialsDropDown";
import {
  BreifInfluencerV2StatusEnum,
  influencerActionsEnum,
} from "@entities/brief/lib/constants";
import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";
import { BriefTimelinePopOver } from "@features/briefTimeline/BriefTimelinePopOver";
import InflunencerCommercialsDropDown from "@features/InfluencerCommercialsV2/InfluencerCommercialsDropDown/InflunencerCommercialsDropDown";
import { IBriefCampaignBriefInfluencer } from "@shared/lib/types/briefCampains";
import {
  IBriefInfluencerV2,
  TimelineEventType,
} from "@shared/lib/types/briefInfluencerV2";
import { InrAmountWordsLine } from "@shared/ui";
import styles from "./styles.module.scss";

const { Text } = Typography;

interface CommercialHistoryEntry {
  date: string;
  action: string;
  amount: number | null;
  by: string;
  notes?: string;
  tips?: string;
  isDeliverbleChanged?: boolean;
}

export function BriefInfluencerCommercials({
  briefInfluencer,
  inBrief = true,
}: {
  briefInfluencer: IBriefInfluencerV2 | IBriefCampaignBriefInfluencer;
  inBrief?: boolean;
}) {
  const [isCommercialsRequestedModal, setIsCommercialsRequestedModal] =
    useState(false);
  const { userDetails } = useGetMe();

  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  const isCurrentUser = inBrief
    ? userDetails?.userEntity?.id === briefInfluencer.createdBy._id
    : false;

  const currency = "₹"; // Default currency, could be made configurable

  const history: CommercialHistoryEntry[] = useMemo(() => {
    const historyEntries: CommercialHistoryEntry[] = [];
    const influencerTimeline = briefInfluencer.timeline || [];

    influencerTimeline.forEach((event) => {
      let action: string = "";
      let amount: number | null = null;
      let notes: string | undefined = undefined;
      let influencerCommercial: number | undefined = undefined;
      let revenue: number | undefined = undefined;
      let targetBrandCost: number | undefined = undefined;
      let targetInfluencerCost: number | undefined = undefined;

      // Match the logic from BriefTimeline for brand timeline
      switch (event.type) {
        case TimelineEventType.InitialInfluencerCostAsked:
          action = "Commercials Asked";
          break;
        case TimelineEventType.InitialInfluencerCostAskedTarget:
          action = `Target Commercial Given: ${
            event.targetInfluencerCost?.cost ?? "-"
          }`;
          break;
        case TimelineEventType.InitialInfluencerCostAccepted:
          action = `Commercial Accepted`;
          amount = event.influencerCost?.cost ?? null;
          break;
        case TimelineEventType.InitialInfluencerCostSubmitted:
          action = `1st Quote Submitted`;
          amount = event.influencerCost?.cost ?? null;
          break;
        case TimelineEventType.InfluencerNegotiationsRequested:
          action = `Negotiation Requested`;
          amount = event.targetInfluencerCost?.cost ?? null;
          break;
        case TimelineEventType.InfluencerNegotiationsAccepted:
          action = `Negotiation Accepted`;
          amount = event.influencerCost?.cost ?? null;
          break;

        case TimelineEventType.InfluencerInitialCost:
          action = `Influencer cost added`;
          amount = event.influencerCost?.cost ?? null;
          break;
        case TimelineEventType.BrandInitialCost:
          action = `Brand price added`;
          amount = event.brandCost?.cost ?? null;
          break;
        case TimelineEventType.NewInfluencerCost:
          action = `New Influencer cost added`;
          amount = event.influencerCost?.cost ?? null;
          break;

        case TimelineEventType.BrandInitialCost:
        case TimelineEventType.NewBrandCost:
          action = `New Brand price added: ${event.brandCost?.cost ?? "-"}`;
          // notes = event.brandCost?.note ?? undefined;
          amount = event.brandCost?.cost ?? null;
          influencerCommercial = event?.brandCost?.influencerCost?.cost;
          revenue = event?.brandCost?.revenue;
          notes = `Influencer Commercial: ${influencerCommercial ?? "-"}
          Revenue: ${revenue ?? "-"}`;
          break;
        case TimelineEventType.NegotiationsRequested:
          action = "Negotiation requested";
          // notes = event.targetRemarks ?? undefined;
          targetBrandCost = event.targetBrandCost?.cost;
          targetInfluencerCost = event.targetInfluencerCost?.cost;
          notes = `Target Brand Cost: ${targetBrandCost ?? "-"}
          Target Influencer Cost: ${targetInfluencerCost ?? "-"}`;
          break;
        default:
          action = event.type;
          break;
      }

      historyEntries.push({
        date: format(new Date(event.createdAt), "MMM dd"),
        action,
        notes,
        amount: amount || amount === 0 ? amount : null,
        // isDeliverbleChanged:
        //   event.type === TimelineEventType.DeliverableAttached,
        by: isCurrentUser
          ? "You"
          : `${event.createdBy.firstName} ${event.createdBy.lastName}`,
      });
    });

    return historyEntries;
  }, [briefInfluencer.brandTimeLine]);

  // if (briefInfluencer?.isBrandDeclined) {
  //   return (
  //     <Tooltip title={briefInfluencer?.brandDeclinedReason}>
  //       <Text className={styles.pendingText}>Brand Declined</Text>
  //     </Tooltip>
  //   );
  // }
  // if (briefInfluencer.isCreatorDeclined) {
  //   return (
  //     <Tooltip title={briefInfluencer?.creatorDeclinedReason}>
  //       <Text className={styles.pendingText}>Creator Declined</Text>
  //     </Tooltip>
  //   );
  // }
  // if (briefInfluencer.isCreatorOnboardPending && inBrief) {
  //   return <Text className={styles.pendingText}> Pending</Text>;
  // }
  // if (briefInfluencer.isDeliverablesPending && inBrief) {
  //   return <Text className={styles.pendingText}> Pending</Text>;
  // }
  // if (!briefInfluencer.isPrimaryContactAdded && inBrief) {
  //   return <Text className={styles.pendingText}>Pending</Text>;
  // }
  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        if (!isDropdownOpen) {
          setIsHovered(false);
        }
      }}
    >
      {briefInfluencer?.influencerCost ? (
        <Space size={5} align="start">
          <div className={styles.priceWithWords}>
            <div className={`${styles.priceRow} ${styles.priceGroup}`}>
              <span
                className={`${styles.priceText} ${styles.priceDefault} ${styles.priceClickable}`}
              >
                {currency}
                {briefInfluencer?.influencerCost.cost}
              </span>
              {inBrief && (
                <BriefTimelinePopOver
                  briefInfluencer={briefInfluencer}
                  type="influencer"
                />
              )}
            </div>
            <InrAmountWordsLine
              value={briefInfluencer?.influencerCost.cost}
              className={styles.amountInWords}
            />
          </div>

          {/* {isHovered ? ( */}
          {briefInfluencer.status !== BreifInfluencerV2StatusEnum.Purchased &&
            inBrief && (
              <InflunencerCommercialsDropDown
                briefInfluencer={briefInfluencer as IBriefInfluencerV2}
                isHovered={isHovered}
                onDropdownOpenChange={setIsDropdownOpen}
                actions={
                  briefInfluencer?.isQueuedForPurchaseLot
                    ? []
                    : [
                        // influencerActionsEnum.addNewInfluencerCommercial,
                        influencerActionsEnum.negotiate,
                      ]
                }
              />
            )}
          {/* ) : (
            false
          )} */}
        </Space>
      ) : !briefInfluencer.isInfluencerCostAsked &&
        briefInfluencer?.isPrimaryContactAdded &&
        !briefInfluencer?.isQueuedForPurchaseLot ? (
        <Space size={5}>
          <Text className={styles.pendingText}>Pending</Text>
          {history.length > 0 && inBrief && (
            <BriefTimelinePopOver
              briefInfluencer={briefInfluencer}
              type="influencer"
            />
            // <Popover
            //   content={historyContent}
            //   // placement={isLastRow ? "top" : "bottom"}
            //   trigger={["hover", "click"]}
            // >
            //   <div className={styles.historyIconWrapper}>
            //     <History size={12} className={styles.historyIcon} />
            //   </div>
            // </Popover>
          )}
          {/* {isHovered ? ( */}
          {/* <InflunencerCommercialsDropDown
            briefInfluencer={briefInfluencer}
            isHovered={isHovered}
            onDropdownOpenChange={setIsDropdownOpen}
            actions={[influencerActionsEnum.addInfluencerCommercial]}
          /> */}
          {/* ) : null} */}
        </Space>
      ) : briefInfluencer?.isInfluencerCostAsked ? (
        <Space size={5}>
          <Text className={styles.pendingText}>Commercials Requested</Text>
          {history.length > 0 && inBrief && (
            <BriefTimelinePopOver
              briefInfluencer={briefInfluencer}
              type="influencer"
            />

            // <Popover
            //   content={historyContent}
            //   // placement={isLastRow ? "top" : "bottom"}
            //   trigger={["hover", "click"]}
            // >
            //   <div className={styles.historyIconWrapper}>
            //     <History size={12} className={styles.historyIcon} />
            //   </div>
            // </Popover>
          )}

          {/* {isHovered ? ( */}
          {/* <InflunencerCommercialsDropDown
            briefInfluencer={briefInfluencer}
            isHovered={isHovered}
            onDropdownOpenChange={setIsDropdownOpen}
            actions={
              briefInfluencer?.isQueuedForPurchaseLot
                ? []
                : [
                    influencerActionsEnum.addInfluencerCommercial,
                    influencerActionsEnum.resend,
                  ]
            }
          /> */}
          {/* ) : null} */}
        </Space>
      ) : (
        <Text className={styles.pendingText}>Pending</Text>
      )}
    </div>
  );
}
